var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.3457V3.3457H15V1.3457H17V3.3457H21C21.5523 3.3457 22 3.79342 22 4.3457V20.3457C22 20.898 21.5523 21.3457 21 21.3457H3C2.44772 21.3457 2 20.898 2 20.3457V4.3457C2 3.79342 2.44772 3.3457 3 3.3457H7V1.3457H9ZM20 11.3457H4V19.3457H20V11.3457ZM11 13.3457V17.3457H6V13.3457H11ZM7 5.3457H4V9.3457H20V5.3457H17V7.3457H15V5.3457H9V7.3457H7V5.3457Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b854f91ef7ff2e20b81c5b6788502f47.svg";
export { ForwardRef as ReactComponent };